import React, { useRef, useState } from 'react';
import { AvatarGroup, Popover } from '@mui/material';
import { useSelector } from 'react-redux';

import AvatarComponent from '@/components/common-components/AvatarComponent/AvatarComponent';
import ShortString from '@/components/common-components/ShortString/ShortString';
import ThreeDotsVertical from '@/components/Icons/icons/ThreeDotsVertical';
import TickIcon2 from '@/components/Icons/icons/TickIcon2';
import TrashIcon from '@/components/Icons/icons/TrashIcon';

interface Props {
  onSelect: (selector: string) => void;
  brand: any;
  totalTeammembers: number;
  isSelected: boolean;
  handleClickRemoveConnectedAccount: (identicon: string) => void;
}

const BrandListItem: React.FC<Props> = ({
  onSelect,
  brand,
  totalTeammembers,
  isSelected,
  handleClickRemoveConnectedAccount,
}) => {
  const [removeAccountEl, setRemoveAccountEl] = useState<HTMLDivElement | null>(null);
  const [showTick, setShowTick] = useState(true);

  const { userDetails } = useSelector((state: any) => state.user);

  const threeDotsRef = useRef<HTMLDivElement | null>(null);

  const isRemovable = brand?.connectedBrandUserId !== userDetails?._id;

  return (
    <>
      <div
        className={`list-item-margin-16 flex flex-between items-center py-3 px-4 border-default rounded-lg multi-brand-list-item ${isSelected ? 'selected' : ''}`}
        onClick={() => {
          onSelect(brand.connectedBrandTeamMemberId);
        }}
        onMouseEnter={() => setShowTick(false)}
        onMouseLeave={() => setShowTick(true)}>
        <div className="flex flex-start items-center gap-2">
          <AvatarComponent src={brand.userProfilePic} size={48} alt={brand?.brandName} />
          <div className="flex flex-col justify-center gap-1 w-full">
            <p className="text-base font-medium text-default">
              <ShortString name={brand?.brandName} stringLength={30} />
            </p>
            <div className="flex flex-start items-center gap-2 w-full">
              <AvatarGroup total={totalTeammembers}>
                {brand?.teamMembers?.map((member: any, index: number) => (
                  <AvatarComponent
                    key={index}
                    src={member?.profile_pic}
                    size={20}
                    alt={`${member?.first_name} ${member?.last_name}`}
                  />
                ))}
              </AvatarGroup>
              <p className="text-xs text-normal text-subdued">
                {totalTeammembers} user{totalTeammembers > 1 ? 's' : ''}
              </p>
            </div>
          </div>

          {isRemovable && (
            <div
              ref={threeDotsRef}
              className={`cursor-pointer remove-account-vertical-dots ${removeAccountEl ? 'active' : ''}`}
              onClick={(e) => {
                e.stopPropagation();
                setRemoveAccountEl(e.currentTarget);
              }}>
              <ThreeDotsVertical />
            </div>
          )}
        </div>

        {isSelected && (showTick || !isRemovable) && !removeAccountEl && (
          <TickIcon2 width={16} height={16} color="var(--icon-highlight)" />
        )}
      </div>
      <Popover
        open={Boolean(removeAccountEl)}
        anchorEl={removeAccountEl}
        onClose={() => setRemoveAccountEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{ zIndex: 9999, marginTop: '4px' }}>
        <div
          className="p-3 text-sm flex flex-start items-center gap-1 cursor-pointer"
          onClick={() => {
            handleClickRemoveConnectedAccount(brand.connectedBrandTeamMemberId);
            setRemoveAccountEl(null);
          }}>
          <TrashIcon />
          Remove Account
        </div>
      </Popover>
    </>
  );
};

export default BrandListItem;
